import { IconBase, IconBaseProps } from 'react-icons';
import { devicesIconManifest } from 'app/agriculture/icons/devices/devicesIconManifest';

export function WeatherStationIcon(props: IconBaseProps) {
    const { id, d } = devicesIconManifest['Weather Station'];

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="WeatherStationIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
